import { render } from "./TextNote.vue?vue&type=template&id=04f372cf"
import script from "./TextNote.vue?vue&type=script&lang=js"
export * from "./TextNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__